import { useAtom } from 'jotai';
import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import useWebSocket from '../wshook';
import { siteDataAtom } from '../../atoms/SiteDataAtom';
import SiteInfoTable from '../tables-charts/SiteInfoTable';
import ConvertTime from '../converters/TimestampConverter';

const FastDataHandler = ({uid}) => {
  const [, setSiteData] = useAtom(siteDataAtom);

    const fetchSiteData = async () => {
    try {
      const response = await axios.get(`https://windmonitoring.net/api/fastdata-fallback/${uid}`);
      const fetchedData = response.data;
      console.log("Data fetched successfully:", fetchedData);

      try {
        updateSiteDataAtom(fetchedData);
      } catch (error) {
        console.error("Error updating SiteAtom:", error);
      }

      return fetchedData;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  };

  const { isLoading, isError, error } = useQuery({
    queryKey: ['FastDataFallback', uid],
    queryFn: fetchSiteData,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    cacheTime: Infinity,
    staleTime: Infinity,
  });

  const handleWebSocketMessage = (data) => {
    const { message } = data;
    console.log('FastDataHandler uid:', uid);
    if (message.UID === uid) {
      updateSiteDataAtom(message);
    }
  };

  function updateSiteDataAtom(data) {
    if (data) {
      let convertedTS = '';
      if (data.Timestamp) {
        let convertedTS = ConvertTime(data.Timestamp);
      }
      setSiteData((prevData) => ({
        ...prevData,
        SiteUID: data.UID,
        Pturb: data.Power,
        RPMMax: data.RPM,
        Vgrid: data.Vgrid,
        Fgrid: data.Fgrid,
        Vdc: data.Vdc,
        DaykWh: data.DaykWh,
        THIS: data.THIS,
        Status: data.Status,
        Timestamp: convertedTS,
      }));

      console.log("Updated SiteAtom with:", data);
    }
  }

  useWebSocket(handleWebSocketMessage);

  return <SiteInfoTable />;
};


const FastDataHandlerWithKey = () => {
  const { uid } = useParams();

  console.log('FastDataHandlerWithKey uid:', uid);

  return <FastDataHandler uid={uid} />;
};

export default FastDataHandlerWithKey;